export enum DomainCategoryEnum {
  MarketComm = 'market-comm',
  BusinessManagement = 'business-management',
  CreaDesign = 'crea-design',
  RhAdminJuridique = 'rh-admin-juridique',
  GestionFinance = 'gestion-finance',
  LogistiqueProduction = 'logistique-production',
  Tech = 'tech',
  ScienceRdIngenierie = 'science-rd-ingenierie',
  SanteSocialCulture = 'sante-social-culture',
  HotellerieRestauration = 'hotellerie-restauration',
}
